import { type EditPhotoWithCropFormState } from '../model/types'
import { ModelsPhotoTag1 as PhotoTag } from '@/shared/api/topli/TopliApi'

export const editPhotoWithCropFormDefault: EditPhotoWithCropFormState = {
  id: 0,
  centerOffsetX: null,
  centerOffsetY: null,
  zoom: 0,
  tag: PhotoTag.Exterior,
}
